// extracted by mini-css-extract-plugin
export var formDescription = "SignupForm-module--form-description--x2bHm";
export var centerVertically = "SignupForm-module--center-vertically--U5bGv";
export var revueFormFooter = "SignupForm-module--revue-form-footer--CMbDU";